import { IQuickReplyBlock } from 'common/builder/blocks/blockInterfaces'
import { getContentNodeNextStep } from 'common/builder/components/chart/FlowChart/lib/utils/getContentNodeNextStep'
import { FlowChartNextStep } from 'common/builder/components/chart/FlowChart/types/FlowChartNextStep'
import { IInstagramNode } from 'common/builder/nodes/nodeInterfaces'

export const getInstagramNodeNextStep = ({
  node,
  quickReplyBlock,
}: {
  node: IInstagramNode
  quickReplyBlock?: IQuickReplyBlock
}): FlowChartNextStep | null => {
  const nextStep = getContentNodeNextStep({ node, quickReplyBlock })

  /**
   * If next step id is different from current node id it is QiockReply fallback next step.
   *
   * QuickReply fallback should be visible even for comment reply nodes
   */
  if (nextStep && nextStep.id !== node.id) {
    return nextStep
  }

  if (node.privateReply) {
    return null
  }

  return nextStep
}
